export const EVENT_RETAIL_ALREADY_CLUB_MEMBER_POPUP = 'EVENT_RETAIL_ALREADY_CLUB_MEMBER_POPUP';
